<style media="screen">

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        padding-top: 71px;
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    input[type=file] {
        display: none;
    }

</style>

<template>

    <el-row>
        <el-form :model="keywordForm" :rules="rules" addAction="businessKeyWord/addKeyWord.action" editAction="businessKeyWord/editKeyWord.action"
                 label-width="100px" ref="keywordForm" selectAction="businessKeyWord/getKeyWord.action" v-form>
            <el-col :span="18" class="basic-margin">

                  <el-form-item label="选择关键词" label-position="left" prop="target">
                      <el-form-item>
                          <el-select v-model="keywordForm.type" >
                              <el-option :value="1" label="黑名单"></el-option>
                              <el-option :value="2" label="白名单"></el-option>
                          </el-select>
                      </el-form-item>
                </el-form-item>

                <el-form-item label="关键词" label-position="left" prop="title">
                    <el-input placeholder="关键词）" v-model="keywordForm.content">
                    </el-input>
                </el-form-item>

               

                <el-form-item class="basic-margin">
                    <el-button type="primary">确定</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-col>
        </el-form>

    </el-row>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  name: 'save-business-key-word',
  extends: BasicPager,
  data: function () {
    return {
      checkAll: false,
      visible: false,
      imageUrl: '',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      targetDbtResult: 1,
      channelOptions: [],
      keywordForm: {
        id: null,
        type: null,
        content: null

      },
      rules: {
        content: [{
          required: true,
          message: '关键词不能为空',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '类型不能为空',
          trigger: 'blur'
        }],
      }
    }
  },
  created: function () {
    // 获取参数
    let params = this.$route.params
    if (params) {
      this.keywordForm.id = params.id
    }
  },
  methods: {

  }
}

</script>
